export const API_URL = process.env.REACT_APP_POSTGREST_URI || "http://localhost:3000";
export const AUTH_API_URL = process.env.REACT_APP_OAUTH_API_URI || "http://localhost:3684";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "resident";
export const MEDIA_STORAGE_URI = process.env.REACT_APP_MEDIA_STORAGE_URI || `http://localhost:3035`;
export const REACT_APP_ARCHIVE_SERVICE_URL = process.env.REACT_APP_ARCHIVE_SERVICE_URL || "http://localhost:3001";
export const TIMETODOORDER = 60; // minutes
